import React from 'react';

import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';

//Componentes auxiliares:
import FileButton from './auxiliars/FileButton';
import ButtonWithStatusModal from '../downloadSourcesResume/auxiliars/ButtonWithStatusModal';

//Scripts auxiliares:
import { getSourceTitleText, getSourceSubtitleText, getDataValidityPeriod } from '../../views/common/downloadSourcesRenderingFunctions';
let dateFormatter = require('../../tools/formatters/dateFormatter');

//Variables auxiliares:
let tableColumnsList = [
    {
        title: "Estado",
        key: "status",
        style: { textAlign: "center", width: 80 }
    },
    {
        title: "Fuente de descarga",
        key: "description",
        style: { textAlign: "center" }
    },
    {
        title: "Fin",
        key: "modified",
        style: { textAlign: "left" }
    },
    {
        title: "Fichero",
        key: "getFile",
        style: { textAlign: "center" }
    }
];

const paginationSize = 5;

//Estilos base:
let paragraphBaseStyles = { textTransform: "none", marginBottom: 0, paddingTop: 5 };

class ProcessesResumeTable extends React.Component {

    constructor() {
        super();

        this.state = {
            targetProcesses: [],
            sortingActiveKey: "",
            sortingActiveDirection: ""
        }
    }

    render() {
        return (
            <React.Fragment>
                <Table>
                    {this.getTableHeaders()}
                    <tbody>
                        {this.getTableRows()}
                    </tbody>
                </Table>

                <hr style={{ marginTop: 0 }} />

                <div style={{ display: "flex", textAlign: "center" }}
                    data-tut="reactour__processesRegistry.processesRegistryTablePagination">

                    <div style={{ flex: "50%", display: "flex", justifyContent: "flex-start" }}>
                        <Button style={{ marginLeft: 5, marginRight: 5 }} outline color="success"
                            disabled={(this.props.activeQuantity >= this.state.targetProcesses.length)}
                            onClick={() => {
                                this.props.updateActiveQuantity(this.state.targetProcesses.length);
                            }}>Ver todo</Button>
                    </div>

                    <div style={{ flex: "50%", display: "flex", justifyContent: "flex-end" }}>
                        <Button style={{ marginLeft: 5, marginRight: 5 }}
                            disabled={(this.props.activeQuantity <= paginationSize)}
                            onClick={() => {
                                if (!(this.props.activeQuantity <= paginationSize)) {
                                    this.props.updateActiveQuantity(this.props.activeQuantity - paginationSize);
                                }
                            }}>Ver menos
                        </Button>

                        <Button color="info" style={{ marginLeft: 5, marginRight: 5 }}
                            disabled={(this.props.activeQuantity > this.state.targetProcesses.length)}
                            onClick={() => {
                                if (!(this.props.activeQuantity > this.state.targetProcesses.length)) {
                                    this.props.updateActiveQuantity(this.props.activeQuantity + paginationSize);
                                }
                            }}>Ver más
                        </Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    componentDidMount() {
        this.setState({ targetProcesses: this.props.targetProcesses || [] });
    }

    componentDidUpdate() {
        if (JSON.stringify(this.state.targetProcesses) !== JSON.stringify(this.props.targetProcesses)) {
            this.setState({ targetProcesses: this.props.targetProcesses });
        }
    }

    //Métodos para el renderizado de los elementos de la tabla:
    getFinishDateLabel = (targetProcess) => {
        if (targetProcess.status !== "IN_PROCESS") {
            return (
                <React.Fragment>
                    <p style={{ marginBottom: 0, paddingLeft: 0 }}>
                        {dateFormatter.getShortDate(new Date(targetProcess.end_date || targetProcess.modified))}
                    </p>
                    <p className="category" style={{ ...paragraphBaseStyles, paddingLeft: 0 }}>
                        {dateFormatter.getShortHour(new Date(targetProcess.end_date || targetProcess.modified))}
                    </p>
                </React.Fragment>
            );
        }
        else {
            return (
                <React.Fragment>
                    <p style={{ marginBottom: 0, paddingLeft: 0 }}>-</p>
                    <p className="category" style={{ ...paragraphBaseStyles, paddingLeft: 0 }}>-</p>
                </React.Fragment>
            );
        }
    }

    getMessageForDataPeriod = (targetProcess) => {
        if (targetProcess) {
            return (
                <p className="category" style={{ ...paragraphBaseStyles, paddingLeft: 0 }}>
                    <b>Periodo: </b>
                    <span>
                        {getDataValidityPeriod(targetProcess)}
                    </span>
                </p>
            );
        }
        else {
            return (
                <span>{"-"}</span>
            );
        }
    }

    getTableHeaders = () => {
        let headersList = [];
        let sortingIcon = undefined;

        for (let i = 0; i < tableColumnsList.length; i++) {
            if (tableColumnsList[i].key === this.state.sortingActiveKey) {
                if (this.state.sortingActiveDirection === "asc") {
                    sortingIcon = <span><i className={"nc-icon nc-minimal-down"} style={{ marginLeft: 4 }}></i></span>;
                }
                else {
                    sortingIcon = <span><i className={"nc-icon nc-minimal-up"} style={{ marginLeft: 4 }}></i></span>;
                }
            }
            else {
                sortingIcon = null;
            }

            headersList.push(
                <th style={{ ...tableColumnsList[i].style, fontSize: 10 }} key={"encabezadoDeFuentes." + i} className="noselect">
                    <p style={{ marginBottom: 0, cursor: "pointer" }}
                        onClick={() => { this.sortProcessesBasedOnKey(tableColumnsList[i].key) }}>
                        {tableColumnsList[i].title}
                        {sortingIcon}
                    </p>
                </th>
            );
        }

        return (
            <thead className="muted-text">
                <tr>
                    {headersList}
                </tr>
            </thead>
        );
    }

    getTableRows = () => {
        let rowsList = [];

        for (let i = 0; i < this.state.targetProcesses.length && i < this.props.activeQuantity; i++) {
            let userCanClickTheButton = (false || this.props.activeUser.is_admin || this.props.activeUser.is_staff);

            rowsList.push(
                <tr key={"key.downloadSource." + i}
                    data-tut={(i === 0) ? "reactour__processesRegistry.processesRegistryTableRowDescription" : ""}>

                    <td style={{ padding: 0 }}>
                        <ButtonWithStatusModal context=""
                            targetProcess={this.state.targetProcesses[i]}
                            downloadSource={this.state.targetProcesses[i].linkedDownloadSource}
                            getStatusButtonClassname={this.props.getStatusButtonClassname}
                            getStatusIconClassname={this.props.getStatusIconClassname}
                            getDownloadSourceTitle={this.props.getDownloadSourceTitle}
                            getTimelineDivClassname={this.props.getTimelineDivClassname}
                            getTimelineIconClassname={this.props.getTimelineIconClassname}
                            cancelDownloadProcess={this.props.cancelDownloadProcess}
                            retryDownloadProcess={this.props.retryDownloadProcess}>

                            <div className="icon-big text-center icon-warning"
                                title={"Ver detalle [" + this.props.getStatusIconTitle(this.state.targetProcesses[i]) + "]"}>
                                <i className={this.props.getStatusIconClassname(this.state.targetProcesses[i])} />
                            </div>
                        </ButtonWithStatusModal>
                    </td>

                    <td>
                        <p style={{ marginBottom: 0 }}>
                            <b>{getSourceTitleText(this.state.targetProcesses[i].linkedDownloadSource.description)}</b>
                            {getSourceSubtitleText(this.state.targetProcesses[i].linkedDownloadSource.description)}
                        </p>

                        {this.getMessageForDataPeriod(this.state.targetProcesses[i])}
                    </td>

                    <td style={{ textAlign: "left" }}>
                        {this.getFinishDateLabel(this.state.targetProcesses[i])}
                    </td>

                    <td style={{ textAlign: "center" }}
                        data-tut={(i === 0) ? "reactour__processesRegistry.processesRegistryTableFileButton" : ""}>
                        <FileButton
                            targetProcess={this.state.targetProcesses[i]}
                            userCanClickTheButton={userCanClickTheButton} />
                    </td>
                </tr>
            );
        }
        return rowsList;
    }

    //Métodos operativos:
    sortProcessesBasedOnKey = (key) => {
        if (key !== "getFile") {
            let sortedProcessesList = [];
            let originalProcessesList = this.state.targetProcesses;

            if (key !== this.state.sortingActiveKey) {
                sortedProcessesList = originalProcessesList.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);

                this.setState({
                    sortingActiveKey: key,
                    sortingActiveDirection: "asc",
                    targetProcesses: sortedProcessesList
                });
            }
            else {
                if (this.state.sortingActiveDirection !== "asc") {
                    sortedProcessesList = originalProcessesList.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);

                    this.setState({
                        sortingActiveKey: key,
                        sortingActiveDirection: "asc",
                        targetProcesses: sortedProcessesList
                    });
                }
                else {
                    sortedProcessesList = originalProcessesList.sort((a, b) => a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0);

                    this.setState({
                        sortingActiveKey: key,
                        sortingActiveDirection: "des",
                        targetProcesses: sortedProcessesList
                    });
                }
            }
        }
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser
    };
};

export default connect(mapStateToProps)(ProcessesResumeTable);